import React from "react";

import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import styles from "./styles.scss";

function Loader(props: Props) {
  return (
    <ul className={styles.loader}>
      <div className={styles.item}>
        <Skeleton className={styles.checkbox} />
        <Skeleton className={styles.name} />
      </div>
      <div className={styles.item}>
        <Skeleton className={styles.checkbox} />
        <Skeleton className={styles.name} />
      </div>
      <div className={styles.item}>
        <Skeleton className={styles.checkbox} />
        <Skeleton className={styles.name} />
      </div>
      <div className={styles.item}>
        <Skeleton className={styles.checkbox} />
        <Skeleton className={styles.name} />
      </div>
      <div className={styles.item}>
        <Skeleton className={styles.checkbox} />
        <Skeleton className={styles.name} />
      </div>
      <div className={styles.item}>
        <Skeleton className={styles.checkbox} />
        <Skeleton className={styles.name} />
      </div>
    </ul>
  );
}

export { Loader };
